(function($, window, document, s, undefined) {

  var $sticky = null;
  var offsetToStickUpon = 0;
  var breakpoint = 992;  // width breakpoint in css, above which to show sticky
  var $backToTop = $('.back-to-top');

  var showOrHideStickyMenu = function showOrHideStickyMenu() {
    if (s.$win.scrollTop() > offsetToStickUpon) {
      $sticky.addClass('visible');
    } else {
      $sticky.removeClass('visible');
    }
  };


  /**
  * Checks whether back to top should be visible,
  */
  var adjustBackToTop = function adjustBackToTop() {
    if (s.$win.scrollTop() > 400) {
      $backToTop.addClass('visible');
    } else {
      $backToTop.removeClass('visible');
    }
  };

  /**
  * Attaches event listeners for back-to-top button.
  */
  var initBackToTop = function initBackToTop() {
    $backToTop = $('.back-to-top');

    s.callOnScroll(adjustBackToTop);

    $backToTop.on('click', function scrollToTop(e) {
      e.preventDefault();

      $('html, body').animate({
        scrollTop: 0
      }, 400);
    });
  };


  var checkForStickyMenus = function checkForStickyMenus() {
    if ($sticky === null) {
      $sticky = $('.sticky');
    }

    if (s.$win.width() >= breakpoint) {
      if (['body-product-list', 'body-product-detail',
           'body-author-detail', 'body-author-list', 'body-help',
           'body-cart-checkout', 'body-cart-checkout-preview',
           'body-customers-dashboard', 'body-shipping-address-change',
           'body-profile-change']
          .indexOf(s.bodyId) > -1) {
        offsetToStickUpon = 400;
        s.$win.on('scroll', showOrHideStickyMenu);
      } else if (s.bodyId === 'product-detail') {
        offsetToStickUpon = 700;
        s.$win.on('scroll', showOrHideStickyMenu);
      }
    } else {
      // Ensure that the sticky is not visible and that the specific listener
      // to the scroll does not exist (i.e. after resize)
      $sticky.removeClass('visible');
      s.$win.off('scroll', showOrHideStickyMenu);

      initBackToTop();
    }
  };

  s.callOnReady(checkForStickyMenus);
  s.callOnResize(checkForStickyMenus);

})(jQuery, this, this.document, window.s);
